import { Injectable } from "@angular/core";
import { LocalConfiguration, LocalConfigurationType } from "../../entities/local-configuration";
import { localDb } from '../local-db.service';

@Injectable({
  providedIn: 'root',
})
export class LocalConfigurationRepository {
 
  get(userId: string, type: LocalConfigurationType): Promise<LocalConfiguration> {
    return localDb.localConfigurations.get([userId, type]);
  }
 
  set(userId: string, type: LocalConfigurationType, data: any): void {
    localDb.localConfigurations.put(new LocalConfiguration(userId, type, data), [userId, type]);
  }
}
 